<div
  class="flex items center gap-2"
  [ngbTooltip]="hasTooltip ? (dueDate | date: tooltipDateFormat) : null"
  [placement]="'top'">
  <svg-icon class="w-5 h-5" [src]="svgIcon"></svg-icon>

  <span class="font-main text-base text-navy-80" [innerHTML]="translationKey | translate: { days }"></span>
</div>
